import {
  DescriptionRounded,
  EditRounded,
  LocalLibraryRounded,
  PlayArrowRounded,
} from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../context/initialValues";
const DeckCard = (props) => {
  const { item, category } = props;
  const navigate = useNavigate();

  const redirectToPlay = (deckName) => {
    const params = new URLSearchParams(window.location.search);
    params.set("deck", deckName);
    params.set("shuffle", "true");

    const url = `/flashcards/play?${params.toString()}`;
    navigate(url);
  };

  return (
    <div
      key={`category-${category.id}-deck-${item.id}`}
      className="deck-card-container"
    >
      <div
        className="deck-card"
        style={{
          borderTop: `8px solid ${COLORS[props.categoryIndex % 4].border}`,
        }}
      >
        <div className="deck-content">
          <IconButton
            className="edit-button"
            fontSize="small"
            sx={{
              "&:hover": {
                backgroundColor: "transparent",
                color: "var(--text)",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              navigate(`/flashcards/deck/${item.id}`);
            }}
          >
            <EditRounded />
          </IconButton>
          <div className="deck-card-top">
            <h6 className="mb-1">{item.name}</h6>
            <p className="mb-0">{item.subtitle}</p>
          </div>
          <div className="deck-card-bottom">
            <div className="side-by-side">
              <p className="mb-0">
                <DescriptionRounded fontSize="small" /> {item.flashcard_count}{" "}
                cards
              </p>
              <p className="mb-0">
                <LocalLibraryRounded fontSize="small" /> {item.study_pile_count}{" "}
                need studying
              </p>
            </div>

            <Button
              color={`${COLORS[props.categoryIndex % 4].button}`}
              disableElevation
              variant="contained"
              size="small"
              className="p-1"
              sx={{
                minWidth: "fit-content",
              }}
              disabled={item.flashcard_count === 0}
              onClick={() => {
                if (item.flashcard_count > 0) redirectToPlay(item.name);
              }}
            >
              <Tooltip
                title={
                  item.flashcard_count === 0
                    ? "Please add cards to this deck."
                    : ""
                }
                placement="bottom"
                arrow
              >
                <PlayArrowRounded sx={{ color: "inherit" }} />
              </Tooltip>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeckCard;
